<template>
  <table class="table is-bordered is-narrowed">
    <thead>
      <th width="3%"><b-icon icon="hashtag"></b-icon></th>
      <th width="7%">C&oacute;digo</th>
      <th width="35%">Descripci&oacute;n</th>
      <th width="7%">U.M.</th>
      <th width="8%">Stock</th>
      <th width="8%">Solicitado</th>
      <th width="8%">Facturado</th>
      <th width="8%">Pickeado</th>
      <th width="8%">Pendiente</th>
      <th v-if="hayAcciones" class="has-text-centered">
        <b-icon icon="cog" size="is-small" />
      </th>
    </thead>
    <pedido-item-detalle-grupo
      v-for="pedido in items"
      :key="`pedido-${pedido.id}`"
      :pedido="pedido"
    />
    <tbody v-if="!hayPedidos">
      <tr>
        <td class="has-text-centered" :colspan="numeroColumnas">
          No hay pedidos pendientes de pickear!
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapGetters } from 'vuex'

import PedidoItemDetalleGrupo from '@/components/monitorZona/PedidoItemDetalleGrupo.vue'

export default {
  name: 'Pedidos',
  components: {
    PedidoItemDetalleGrupo
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    hayPedidos() {
      return this.items.length > 0
    },
    hayAcciones() {
      return (
        (this.bodega.puedeReimprimir || this.bodega.puedePickearVendedor) &&
        // Si usuario tiene rol Monitor, no se muestran acciones
        !this.bodega.roles.some((rol) => rol.id === 6)
      )
    },
    numeroColumnas() {
      const cols = 11
      if (this.hayAcciones) return cols + 1
      return cols
    },
    esUsuarioMonitor() {
      return false
    }
  }
}
</script>
